<template>
    <component
        :is="is"
        :background="background"
        :data="data"
        :has-eager-image="hasEagerImage"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Color, ContentComponentItemFragment } from '@/graphql/api'
import { assertNever } from '@/helpers'

import ContentButton from '@/components/cms/component/content/ContentButton.vue'
import ContentText from '@/components/cms/component/content/ContentText.vue'
import ContentTitle from '@/components/cms/component/content/ContentTitle.vue'
import DebugComponent from '@/components/cms/component/DebugComponent.vue'
import ContentSpacer from '@/components/cms/component/content/ContentSpacer.vue'
import ContentImage from '@/components/cms/component/content/ContentImage.vue'
import ContentOrderedList from '@/components/cms/component/content/ContentOrderedList.vue'

const props = defineProps<{
    data: ContentComponentItemFragment
    background?: Color
    hasEagerImage?: boolean
}>()

const is = computed<any>(() => {
    const type = props.data.__typename

    switch (type) {
        case 'ComponentButton':
            return ContentButton
        case 'ComponentText':
            return ContentText
        case 'ComponentTitle':
            return ContentTitle
        case 'ComponentSpacer':
            return ContentSpacer
        case 'ComponentImage':
            return ContentImage
        case 'ComponentOrderedList':
            return ContentOrderedList
        default:
            return assertNever(type, DebugComponent)
    }
})

const hasEagerImage = computed(() => Boolean(props.hasEagerImage))
</script>
